module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-video"
  }, [_c('iframe', {
    ref: "video",
    staticStyle: {
      "background-color": "#000000"
    },
    attrs: {
      "src": _vm.videoParseUrl,
      "frameborder": "0",
      "width": "100%",
      "height": "100%",
      "webkitallowfullscreen": "",
      "mozallowfullscreen": "",
      "allowfullscreen": "",
      "fullscreen": "",
      "allow": "autoplay"
    },
    on: {
      "load": _vm.loadVideo
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e18c11e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lvideo.vue
// module id = 1559
// module chunks = 1